export const Separator = 1

export const None = 0

export const SubMenu = 4

export const Checked = 2

export const Unchecked = 3

export const Disabled = 5

export const RestoreFocus = 6

export const Ignore = 7
